module.exports = __webpack_public_path__ + "img/video2.28f604b7.jpg";